import { Injectable } from '@angular/core';
import { OccProductSearchAdapter, ProductSearchPage, SearchConfig } from '@spartacus/core';
import { Observable, finalize, shareReplay } from 'rxjs';

@Injectable()
export class SikoB2BProductSearchAdapter extends OccProductSearchAdapter {
   private readonly inFlightRequests = new Map<string, Observable<ProductSearchPage>>();

   override search(query: string, searchConfig: SearchConfig): Observable<ProductSearchPage> {
      // Use the final OCC endpoint as the identity of the request.
      const requestKey = this.getSearchEndpoint(query, searchConfig);

      const existingRequest = this.inFlightRequests.get(requestKey);

      if (existingRequest) {
         return existingRequest;
      }

      const request$ = super.search(query, searchConfig).pipe(
         finalize(() => {
            this.inFlightRequests.delete(requestKey);
         }),
         shareReplay({
            bufferSize: 1,
            refCount: false,
         })
      );

      this.inFlightRequests.set(requestKey, request$);

      return request$;
   }
}
